export class DistrictModel{
    DistrictId : any;
    IsActive : any;
    DistrictName : any;
    DistrictCode : any;
    ProvinceId:any;
}
export class edit{
    DistrictId : any;
    IsActive : any;
    DistrictName : any;
    DistrictCode : any;
    Code:any;
    ProvinceId:any;
}
export class filt{
    DistrictId : any;
    IsActive : any;
    DistrictName : any;
    DistrictCode : any;
    ProvinceId:any;
}